/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-console */
import React, { useEffect, useRef, useState, useCallback } from 'react';

import { toast } from 'react-hot-toast';
import { v4 } from 'uuid';
import axios from 'axios';

import { Form } from '@unform/web';
import { Col, Row } from 'reactstrap';

import { FaCheck, FaTrash } from 'react-icons/fa';

import L from 'leaflet';
import api2 from '~/services/api2';
import {
  Button,
  IconExchange,
  IconTrashFilled,
  Spinner,
  Switch,
} from 'takeat-design-system-ui-kit';
import { RadioGroup } from './RadioGroup';
import SearchInput from './SearchInput';

import 'leaflet/dist/leaflet.css';

import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';

import {
  Card,
  Map,
  SearchBtn,
  CheckButton,
  TrashButton,
  NumberInput,
  InputStyled,
  TaxTitle,
  CurrencyWrapper,
} from './styles';
import { BRLCurrencyInput } from '~/components/BRLCurrencyInput';

function MapEditor({ deliveryTypeChange, isTypeChanging }) {
  const [allAreas, setAllAreas] = useState([]);

  // Indica se algum dado foi alterado em caso positivo o botão é habilitado
  const [changed, setChanged] = useState([]);

  const fitZoom = useCallback(() => {
    const layers = L.mainMap.pm.getGeomanLayers();

    if (layers.length) {
      const group = new L.FeatureGroup(layers);

      L.mainMap.fitBounds(group.getBounds());
    }
  }, []);

  const updateMap = useCallback(async () => {
    const translation = {
      buttonTitles: {
        drawPolyButton: 'Desenhar uma região livre',
        drawRectButton: 'Desenhar uma região retangular',
        editButton: 'Alterar o formato de uma região',
        dragButton: 'Mover uma região de lugar',
        cutButton: 'Selecionar parte de uma região para remover',
        deleteButton: 'Apagar uma região',
      },
      zoom: {
        zoomInTitle: 'Aumentar o zoom do mapa',
        zoomOutTitle: 'Diminuir o zoom do mapa',
      },
    };

    let areas = [];
    let address = null;

    try {
      const { data } = await api2.get('/restaurants/delivery-areas');

      areas = data.areas;
      address = data.address;
    } catch (err) {
      console.error('Failed to load distances');
    }

    // TODO: Adicionar tratamento para restaurantes sem endereço
    const vitoria_centro = [-20.3196699, -40.338479];

    const map_center = address?.latitude
      ? [address.latitude, address.longitude]
      : vitoria_centro;

    const map = L.map('leaflet-map', {
      zoomControl: false,
    }).setView(map_center, 13);

    L.control.zoom(translation.zoom).addTo(map);

    L.mainMap = map;

    // L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    //   maxZoom: 19,
    //   attribution:
    //     '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    // }).addTo(map);

    L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution:
        '&copy; <a href="https://www.google.com/maps">Google Maps</a>',
    }).addTo(map);

    map.pm.addControls({
      editMode: true,
      drawMarker: false,
      drawCircle: false,
      drawCircleMarker: false,
      drawText: false,
      drawPolyline: false,
      rotateMode: false,
      drawPolygon: true,
      removalMode: true,
    });

    map.pm.setLang('br_custom', translation, 'pt_br');

    const pos = map_center;

    const icon = L.icon({
      iconUrl: '/marker-icon.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [-3, -76],
    });

    L.marker(pos, { icon, pmIgnore: true }).addTo(map);

    areas.forEach((area) => {
      area.key = v4();

      const feature = {
        type: 'Feature',
        geometry: area.area,
        properties: {
          key: area.key,
        },
      };

      const layer = L.geoJSON(feature).addTo(map);
      area.layer = layer;
    });

    fitZoom();
    setAllAreas(areas);
    setChanged(new Array(areas.length).fill(false));
  }, [fitZoom]);

  useEffect(() => {
    updateMap();
  }, [updateMap]);

  // Adiciona eventos de layer
  const addEventsToLayer = useCallback(
    (layer, created) => {
      let layer_json = layer.toGeoJSON();

      if (layer_json.type === 'FeatureCollection') {
        [layer_json] = layer_json.features;
      }

      layer.off('mouseover');
      layer.on('mouseover', () => {
        layer.setStyle({ color: '#08FF08' });
        layer.bringToFront();

        const found = allAreas.find((a) => a.key === layer_json.properties.key);

        if (found) {
          const price = parseFloat(found.price).toFixed(2);
          const html = `<b>${found.name || 'Sem nome'}<b><br>R$${price}`;
          layer.bindTooltip(html);
          layer.openTooltip();
        }
      });

      // layer.off('click');
      // layer.on('click', () => {
      //   const found = allAreas.find((a) => a.key === layer_json.properties.key);
      //   if (found) {
      //     const anchor = document.getElementById(found.key);
      //     anchor.scrollIntoView({ behavior: 'smooth' });
      //     anchor.style.borderBottom = '2px solid #3bd2c1';
      //   }
      // });

      layer.off('mouseout');
      layer.on('mouseout', () => {
        layer.setStyle({ color: '#3388ff' });
        layer.unbindTooltip();

        const found = allAreas.find((a) => a.key === layer_json.properties.key);

        if (found) {
          const anchor = document.getElementById(found.key);
          anchor.style.borderBottom = 'none';
        }
      });

      layer.off('pm:cut');
      layer.on('pm:cut', async (event) => {
        const found = allAreas.find((a) => a.key === layer_json.properties.key);

        if (!found) {
          return;
        }

        // Toda vez que uma layer é recortada uma nova é criada
        const { layer: new_layer } = event;

        try {
          const { id } = found;

          const new_layer_json = new_layer.toGeoJSON();

          const data = {
            area: new_layer_json.geometry,
          };

          await api2.put(`/restaurants/delivery-areas/${id}`, data);

          new_layer.feature = new_layer_json;
          new_layer.feature.properties = {
            key: found.key,
          };

          found.area = new_layer_json.geometry;
          found.layer = new_layer;

          addEventsToLayer(new_layer);

          toast.success('Região atualizada.');
        } catch (err) {
          console.error('Erro ao salvar região.', err);
          toast.error('Erro ao salvar região.');

          new_layer.remove();

          // Revertendo a edição feita no mapa
          const feature = {
            type: 'Feature',
            geometry: found.area,
            properties: {
              key: found.key,
            },
          };

          const revertedLayer = L.geoJSON(feature).addTo(L.mainMap);
          found.layer = revertedLayer;

          addEventsToLayer(revertedLayer);
        }
      });

      layer.off('pm:update');
      layer.on('pm:update', async (event) => {
        const found = allAreas.find((a) => a.key === layer_json.properties.key);

        if (!found) {
          return;
        }

        const { layer: new_layer } = event;
        const new_layer_json = new_layer.toGeoJSON();

        try {
          const { id } = found;

          const data = {
            area: new_layer_json.geometry,
          };

          await api2.put(`/restaurants/delivery-areas/${id}`, data);

          found.area = new_layer_json.geometry;
          found.layer = new_layer;

          toast.success('Região atualizada.');
        } catch (err) {
          console.error('Erro ao salvar região.', err);
          toast.error('Erro ao salvar região.');

          layer.remove();

          // Revertendo a edição feita no mapa
          const feature = {
            type: 'Feature',
            geometry: found.area,
            properties: {
              key: found.key,
            },
          };

          const revertedLayer = L.geoJSON(feature).addTo(L.mainMap);
          found.layer = revertedLayer;

          addEventsToLayer(revertedLayer);
        }
      });

      layer.off('pm:remove');
      layer.on('pm:remove', async (e) => {
        const idx = allAreas.findIndex(
          (a) => a.key === layer_json.properties.key
        );

        if (idx < 0) {
          return;
        }

        try {
          const found = allAreas[idx];

          await api2.delete(`/restaurants/delivery-areas/${found.id}`);

          changed.splice(idx, 1);
          allAreas.splice(idx, 1);

          setAllAreas([...allAreas]);
          setChanged([...changed]);

          toast.success('Deletado com sucesso!');
        } catch (err) {
          layer.addTo(L.mainMap);

          toast.error('Não foi possível deletar!');
        }
      });

      if (created) {
        setAllAreas([created, ...allAreas]);
        setChanged([true, ...changed]);
      }
    },
    [allAreas, changed]
  );

  const addEventsToMap = useCallback(() => {
    if (!L.mainMap) {
      return;
    }

    const map = L.mainMap;

    // Usando 'off' para evitar que um mesma função
    // seja disparada 2 vezes quando o evento ocorrer
    map.off('pm:create');
    map.on('pm:create', async (e) => {
      const { layer } = e;

      const newArea = {
        key: v4(),
        area: layer.toGeoJSON().geometry,
        name: null,
        price: '0.00',
        is_active: true,
      };

      try {
        const response = await api2.post(
          '/restaurants/delivery-areas',
          newArea
        );
        const created = response.data;

        newArea.id = created.id;
        newArea.layer = e.layer;

        e.layer.feature = e.layer.toGeoJSON();
        e.layer.feature.properties.key = newArea.key;

        addEventsToLayer(e.layer, newArea);

        toast.success('Região criada.');
      } catch (err) {
        console.error('Erro ao criar região.', err);
        toast.error('Erro ao criar região.');

        layer.remove();
      }
    });

    L.mainMap.pm.getGeomanLayers().map((l) => addEventsToLayer(l));
  }, [addEventsToLayer]);

  useEffect(() => {
    addEventsToMap();
  }, [addEventsToMap]);

  async function queryOpenStreetMap(place_name) {
    try {
      const response = await axios.get(
        'https://nominatim.openstreetmap.org/search.php',
        {
          params: {
            q: place_name,
            polygon_geojson: 1,
            format: 'json',
            polygon_threshold: 0.0005,
          },
        }
      );

      const polygons = response.data.filter(
        (r) => r.geojson.type.toLowerCase() !== 'linestring'
      );

      return { data: polygons };
    } catch (e) {
      console.log('Error queryOpenStreetMap', e);
      return { data: [] };
    }
  }

  const isSearching = useRef(false);

  const search = useCallback(
    async (data) => {
      if (!L.mainMap) {
        return;
      }

      if (isSearching.current) {
        return;
      }

      isSearching.current = true;

      try {
        // const response = await api2.get(
        //   `/restaurants/delivery-areas/search/${encodeURIComponent(
        //     data.address
        //   )}`
        // );

        const response = await queryOpenStreetMap(data.address);

        if (response.data.length) {
          const filtered = response.data
            .filter((e) => e.class === 'boundary')
            .slice(0, 3)
            .map(({ geojson: geometry, display_name }, i) => {
              if (geometry.type === 'MultiPolygon') {
                geometry.type = 'Polygon';
                geometry.coordinates = geometry.coordinates[0];
              }

              return {
                value: i + 1,
                label: display_name,
                geometry,
              };
            });

          // Se não encontrou uma região, tenta mover o mapa para o lugar buscado
          if (filtered.length === 0) {
            const placeFound = response.data.find((e) => e.class === 'place');

            if (placeFound) {
              const [lat1, lat2, lng1, lng2] = placeFound.boundingbox;

              L.mainMap.flyToBounds([
                [lat1, lng1],
                [lat2, lng2],
              ]);
            }

            toast.error('Região não encontrada.');
            return;
          }

          const { geometry } = filtered[0];

          const newArea = {
            key: v4(),
            area: geometry,
            name: data.address,
            price: '0.00',
            is_active: true,
          };

          const response2 = await api2.post(
            '/restaurants/delivery-areas',
            newArea
          );

          const created = response2.data;

          // Aternatives versions of the searched area
          const alternatives = filtered.length > 1 ? filtered : null;

          const feature = {
            type: 'Feature',
            geometry,
            properties: {
              key: newArea.key,
            },
          };

          const layer = L.geoJSON(feature).addTo(L.mainMap);

          newArea.id = created.id;
          newArea.layer = layer;
          newArea.alternatives = alternatives;
          newArea.alternativeSelected = 1;

          addEventsToLayer(layer, newArea);

          L.mainMap.flyToBounds(layer.getBounds());
        } else {
          toast('Região não encontrada.', {
            icon: '⚠️',
            style: {
              border: '2px solid #f9e076',
            },
          });
        }
      } catch (e) {
        console.error('Failed to search', e);
        toast.error('Endereço não encontrado.');
      } finally {
        isSearching.current = false;
      }
    },
    [addEventsToLayer]
  );

  const handleActiveChange = useCallback(
    (area, i) => {
      const updatedAreas = [...allAreas];
      updatedAreas[i] = { ...updatedAreas[i], is_active: !area.is_active };

      const updatedChanged = [...changed];
      updatedChanged[i] = true;

      setAllAreas(updatedAreas);
      setChanged(updatedChanged);
    },
    [allAreas, changed]
  );

  const handleNameChange = useCallback(
    (e, i) => {
      const updatedAreas = [...allAreas];
      updatedAreas[i] = { ...updatedAreas[i], name: e.target.value };

      const updatedChanged = [...changed];
      updatedChanged[i] = true;

      setAllAreas(updatedAreas);
      setChanged(updatedChanged);
    },
    [allAreas, changed]
  );

  const handleNumberChange = useCallback(
    (e, i) => {
      const updatedAreas = [...allAreas];
      updatedAreas[i] = { ...updatedAreas[i], price: e };

      const updatedChanged = [...changed];
      updatedChanged[i] = true;

      setAllAreas(updatedAreas);
      setChanged(updatedChanged);
    },
    [allAreas, changed]
  );

  const handleTimeChange = useCallback(
    (e, i) => {
      const updatedAreas = [...allAreas];
      updatedAreas[i] = { ...updatedAreas[i], time: e.target.value };

      const updatedChanged = [...changed];
      updatedChanged[i] = true;

      setAllAreas(updatedAreas);
      setChanged(updatedChanged);
    },
    [allAreas, changed]
  );

  const handleAlternativeChange = useCallback(
    (value, i) => {
      const currentArea = allAreas[i];

      if (currentArea.alternativeSelected !== value) {
        currentArea.layer.remove();

        const { geometry } = currentArea.alternatives[value - 1];

        const feature = {
          type: 'Feature',
          geometry,
          properties: {
            key: currentArea.key,
          },
        };

        const newLayer = L.geoJSON(feature).addTo(L.mainMap);

        const updatedArea = {
          ...currentArea,
          area: geometry,
          layer: newLayer,
          alternativeSelected: value,
        };

        const updatedAreas = [...allAreas];
        updatedAreas[i] = updatedArea;

        const updatedChanged = [...changed];
        updatedChanged[i] = true;

        setAllAreas(updatedAreas);
        setChanged(updatedChanged);

        addEventsToLayer(newLayer);
        L.mainMap.flyToBounds(newLayer.getBounds());
      }
    },
    [allAreas, changed, addEventsToLayer]
  );

  const saveEditedArea = useCallback(
    async (i) => {
      const area = allAreas[i];
      console.log(area);
      const { id, name, price, area: geo, time, is_active } = area;

      const data = { name, price, area: geo, time, is_active };

      try {
        await api2.put(`/restaurants/delivery-areas/${id}`, data);
        const updatedAreas = [...allAreas];
        updatedAreas[i] = { ...updatedAreas[i], alternatives: null };
        setAllAreas(updatedAreas);

        const updatedChanged = [...changed];
        updatedChanged[i] = false;
        setChanged(updatedChanged);

        toast.success('Alterações salvas com sucesso!');
      } catch (e) {
        toast.error('Não foi possível salvar a alteração!');
      }
    },
    [allAreas, changed]
  );

  const deleteArea = useCallback(
    async (i) => {
      const { id } = allAreas[i];

      try {
        await api2.delete(`/restaurants/delivery-areas/${id}`);

        changed.splice(i, 1);
        const [area] = allAreas.splice(i, 1);

        if (area) {
          // Removendo layer do mapa
          area.layer.remove();
        }

        setAllAreas([...allAreas]);
        setChanged([...changed]);

        toast.success('Deletado com sucesso!');
      } catch (e) {
        toast.error('Não foi possível deletar!');
      }
    },
    [allAreas, changed]
  );

  return (
    <Card>
      <Row>
        <TaxTitle>Taxa por Área</TaxTitle>
      </Row>
      <Row style={{ margin: 0, height: '100%' }}>
        <Col md="6" style={{ padding: 0, paddingRight: 3 }}>
          <Map id="leaflet-map" style={{ zIndex: 2 }}>
            {' '}
          </Map>
        </Col>

        <Col md="6" style={{ height: '100%' }}>
          <Button
            variant="outlined"
            style={{
              background: '#fff',
              marginBottom: 10,
            }}
            icon={isTypeChanging ? <Spinner /> : <IconExchange />}
            onClick={() => deliveryTypeChange('distance')}
          >
            Mudar para limitar por raio
          </Button>
          <Row style={{ margin: '0px 0px 10px 0px' }}>
            Para encontrar a região desejada recomendamos buscar por "Bairro -
            Cidade - Estado" ou "Cidade - Estado"
          </Row>

          <Form onSubmit={(data) => search(data)}>
            <Row
              style={{
                alignItems: 'center',
                paddingLeft: 3,
                margin: '0 0 10px 0',
              }}
            >
              <Col md="10" style={{ padding: '0 10px 0 0' }}>
                <SearchInput placeholder="Busque um endereço" name="address" />
              </Col>
              <Col md="2" style={{ padding: '0px' }}>
                <Button
                  variant="outlined"
                  style={{ background: '#fff' }}
                  type="submit"
                >
                  Buscar
                </Button>
              </Col>
            </Row>
          </Form>

          <Row
            style={{
              height: '44px',
              fontWeight: 'bold',
              color: '#555',
              alignItems: 'center',
            }}
          >
            <Col
              md="1"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Ativo
            </Col>
            <Col md="5" style={{ padding: '0px 0px 0px 10px' }}>
              {' '}
              Nome da região{' '}
            </Col>
            <Col md="2" style={{ padding: '0px 0px 0px 10px' }}>
              {' '}
              Taxa{' '}
            </Col>
            <Col md="2" style={{ padding: '0px 0px 0px 10px' }}>
              {' '}
              Tempo{' '}
            </Col>
            <Col md="2" style={{ padding: '0px 0px 0px 10px' }}>
              {' '}
              Ações{' '}
            </Col>
          </Row>

          <Row
            style={{
              height: 'calc(100% - 154px)',
              alignContent: 'flex-start',
              paddingRight: '5px',
            }}
          >
            {allAreas.length === 0 && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  color: '#666',
                }}
              >
                Nenhuma região cadastrada
              </div>
            )}

            {allAreas.map((area, i) => {
              return (
                <div
                  id={area.key}
                  key={area.key}
                  style={{
                    padding: !area.alternatives ? '0 5px' : '5px',
                    borderRadius: !area.alternatives ? '0' : '4px',
                  }}
                >
                  <Row style={{ margin: '0', padding: '0' }}>
                    <Col
                      md="1"
                      style={{
                        padding: '0px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Switch
                        id={`${area.id}`}
                        onChange={() => handleActiveChange(area, i)}
                        checked={area.is_active}
                      />
                    </Col>
                    <Col md="5" style={{ padding: '4px' }}>
                      <InputStyled
                        name="name"
                        type="text"
                        placeholder="Escolha um nome"
                        value={area.name}
                        onChange={(e) => handleNameChange(e, i)}
                      />
                    </Col>
                    <Col md="2" style={{ padding: '4px' }}>
                      <CurrencyWrapper>
                        <BRLCurrencyInput
                          hasPrefix
                          isCurrency
                          name="value"
                          value={area.price}
                          onChange={(e) => handleNumberChange(e.value, i)}
                        />
                      </CurrencyWrapper>
                    </Col>
                    <Col md="2" style={{ padding: '4px' }}>
                      <InputStyled
                        name="time"
                        placeholder="Defina um tempo"
                        value={area.time}
                        onChange={(e) => handleTimeChange(e, i)}
                      />
                    </Col>
                    <Col md="2" style={{ padding: '4px' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <CheckButton
                          disabled={!changed[i]}
                          onClick={() => saveEditedArea(i)}
                        >
                          <FaCheck />
                        </CheckButton>

                        <IconTrashFilled
                          onClick={() => deleteArea(i)}
                          fill="#C8131B"
                          style={{
                            fontSize: 24,
                            paddingLeft: 4,
                          }}
                        />
                      </div>
                    </Col>
                  </Row>

                  {area.alternatives ? (
                    <Row style={{ margin: '0', padding: '0' }}>
                      <span
                        style={{
                          padding: '6px',
                          color: '#777',
                          fontSize: '12px',
                          fontWeight: 'bold',
                        }}
                      >
                        Escolha uma das regiões encontradas com mesmo nome:
                      </span>
                      <RadioGroup
                        labelStyle={{ fontSize: '14px' }}
                        options={area.alternatives}
                        selected={area.alternativeSelected}
                        onClick={(e) => handleAlternativeChange(e, i)}
                      />
                    </Row>
                  ) : (
                    <></>
                  )}
                </div>
              );
            })}
          </Row>
        </Col>
      </Row>
    </Card>
  );
}

export default MapEditor;
